<div
  rt-overlay-origin
  #timezoneDropdownTrigger="rtOverlayOrigin"
  [class.active]="timezoneDropdown.open"
  [attr.margin-tb-small-x]="hasMargin ? hasMargin : null"
  (click)="toggle(timezoneDropdown)"
  class="timezone"
>
  <div #trigger>
    <ng-content></ng-content>
  </div>
  <div *ngIf="trigger.children.length == 0">
    <p *ngIf="!dropdown && !short && !underlinedVariant">{{ timeZoneString }}</p>
    <div
      *ngIf="dropdown && !underlinedVariant && !short"
      [class.dropdownOpened]="timezoneDropdown.open"
      class="only-dropdown"
      layout
      layout-align-items-center
    >
      <p>{{ timeZoneString }}</p>
      <div class="arrow-dropdown"></div>
    </div>
    <rt-button
      *ngIf="short && !underlinedVariant"
      [class.dropdownOpened]="timezoneDropdown.open"
      variant="plain"
      [dropdown]="true"
    >
      {{ timeZoneString }}
    </rt-button>
    <rt-input
      *ngIf="underlinedVariant"
      [dropdown]="true"
      [value]="timeZoneString"
      [readOnly]="true"
      [class.dropdownOpened]="timezoneDropdown.open"
      [dropdownIconHasMargin]="dropdownIconHasMargin"
      variant="underlined has-dropdown"
    >
    </rt-input>
  </div>
</div>
<ng-template
  #timezoneDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [origin]="timezoneDropdownTrigger"
  [positions]="positions"
  (backdropClick)="toggle(timezoneDropdown)"
>
  <rt-time-zone-picker-dropdown
    (close)="toggle(timezoneDropdown)"
    (zoneSelect)="onZoneSelect($event, timezoneDropdown)"
  >
  </rt-time-zone-picker-dropdown>
</ng-template>
